import { render, staticRenderFns } from "./ReviewsList.vue?vue&type=template&id=8c0b71b0&scoped=true"
import script from "./ReviewsList.vue?vue&type=script&lang=js"
export * from "./ReviewsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0b71b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c0b71b0')) {
      api.createRecord('8c0b71b0', component.options)
    } else {
      api.reload('8c0b71b0', component.options)
    }
    module.hot.accept("./ReviewsList.vue?vue&type=template&id=8c0b71b0&scoped=true", function () {
      api.rerender('8c0b71b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/ReviewsList.vue"
export default component.exports